import { render, staticRenderFns } from "./qiye.vue?vue&type=template&id=2d5a5bd9&scoped=true&"
import script from "./qiye.vue?vue&type=script&lang=js&"
export * from "./qiye.vue?vue&type=script&lang=js&"
import style0 from "./qiye.vue?vue&type=style&index=0&id=2d5a5bd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5a5bd9",
  null
  
)

export default component.exports